(function() {
  'use strict';

  var WISHLIST_STORAGE_KEY = 'shopify_wishlist';
  var wrapper = document.querySelector('[data-favorites-wrapper]');

  if (!wrapper) {
    return;
  }

  var listContainer = wrapper.querySelector('[data-favorites-list]');
  var emptyState = wrapper.querySelector('[data-favorites-empty]');
  var loadingState = wrapper.querySelector('[data-favorites-loading]');
  var statusMessage = wrapper.querySelector('[data-favorites-status]');
  var sectionContainer = wrapper.closest('[data-favorites-section]');
  var actionsContainer = sectionContainer
    ? sectionContainer.querySelector('[data-favorites-actions]')
    : document.querySelector('[data-favorites-actions]');
  var clearButton = (sectionContainer || wrapper).querySelector('[data-favorites-clear]');
  var removeLabel = wrapper.getAttribute('data-remove-label') || 'Remove';
  var viewLabel = wrapper.getAttribute('data-view-label') || 'View product';

  if (!listContainer || !emptyState || !loadingState || !statusMessage) {
    return;
  }

  if (clearButton) {
    clearButton.addEventListener('click', function() {
      setWishlist([]);
      announce('All favorites removed.');
    });
  }

  listContainer.addEventListener('click', function(event) {
    var removeButton = event.target.closest('[data-remove-favorite]');
    if (!removeButton) {
      return;
    }

    var variantId = removeButton.getAttribute('data-remove-favorite');
    if (!variantId) {
      return;
    }

    removeFavorite(String(variantId));
  });

  window.addEventListener('wishlist:updated', renderFavorites);

  renderFavorites();

  function renderFavorites() {
    var wishlist = getWishlist();

    if (!wishlist.length) {
      listContainer.innerHTML = '';
      emptyState.hidden = false;
      loadingState.hidden = true;
      if (clearButton) {
        clearButton.hidden = true;
      }
      if (actionsContainer) {
        actionsContainer.hidden = true;
      }
      return;
    }

    var hasMultiple = wishlist.length > 1;

    emptyState.hidden = true;
    loadingState.hidden = false;
    if (clearButton) {
      clearButton.hidden = !hasMultiple;
    }
    if (actionsContainer) {
      actionsContainer.hidden = !hasMultiple;
    }

    var promises = wishlist.map(ensureEntryDetails);

    Promise.all(promises)
      .then(function(entries) {
        var updatedEntries = [];
        var hasChanges = false;
        listContainer.innerHTML = '';

        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (!entry || !entry.variantId) {
            hasChanges = true;
            continue;
          }

          if (entry.__updated) {
            hasChanges = true;
            delete entry.__updated;
          }

          updatedEntries.push(entry);
          listContainer.appendChild(renderFavoriteItem(entry));
        }

        if (!updatedEntries.length) {
          if (clearButton) {
            clearButton.hidden = true;
          }
          if (actionsContainer) {
            actionsContainer.hidden = true;
          }
          emptyState.hidden = false;
        } else {
          var moreThanOne = updatedEntries.length > 1;
          if (clearButton) {
            clearButton.hidden = !moreThanOne;
          }
          if (actionsContainer) {
            actionsContainer.hidden = !moreThanOne;
          }
        }

        if (hasChanges) {
          setWishlist(updatedEntries);
        }
      })
      .catch(function() {
        announce('There was a problem loading your favorites.');
      })
      .finally(function() {
        loadingState.hidden = true;
      });
  }

  function renderFavoriteItem(entry) {
    var item = document.createElement('article');
    item.className = 'fl-item';
    item.setAttribute('data-variant-id', entry.variantId);

    var productUrl = getProductUrl(entry);
    var productTitle = entry.productTitle || 'View product';
    var productBrand = entry.productBrand ? String(entry.productBrand).trim() : '';
    var productImage = entry.productImage || '';
    var productImageAlt = entry.productImageAlt || productTitle;
    var priceMarkup = buildPriceMarkup(entry.productPrice, entry.productComparePrice);
    var imageMarkup = '';

    if (productImage) {
      imageMarkup = '<img class="fl-item__image" src="' + escapeHtmlAttribute(productImage) + '" alt="' + escapeHtmlAttribute(productImageAlt) + '">';
    }

    var brandMarkup = productBrand
      ? '<span class="fl-item__brand">' + escapeHtml(productBrand) + '</span>'
      : '';

    item.innerHTML =
      '<div class="fl-item__media">' +
      (productUrl
        ? '<a class="fl-item__media-link" href="' + escapeHtmlAttribute(productUrl) + '">' + imageMarkup + '</a>'
        : imageMarkup) +
      '</div>' +
      '<div class="fl-item__details">' +
      brandMarkup +
      (productUrl
        ? '<a class="fl-item__title" href="' + escapeHtmlAttribute(productUrl) + '">' + escapeHtml(productTitle) + '</a>'
        : '<span class="fl-item__title">' + escapeHtml(productTitle) + '</span>') +
      priceMarkup +
      '<div class="fl-item__actions">' +
      '<button type="button" class="fl-item__remove link" data-remove-favorite="' + escapeHtmlAttribute(entry.variantId) + '">' + escapeHtml(removeLabel) + '</button>' +
      '</div>' +
      '</div>';

    return item;
  }

  function buildPriceMarkup(price, comparePrice) {
    if (price === undefined || price === null || isNaN(price)) {
      return '';
    }

    var priceHtml = '<span class="fl-item__price-current">' + formatMoney(price) + '</span>';

    if (comparePrice && !isNaN(comparePrice) && comparePrice > price) {
      priceHtml =
        '<span class="fl-item__price-old">' + formatMoney(comparePrice) + '</span>' +
        priceHtml;
    }

    return '<div class="fl-item__price">' + priceHtml + '</div>';
  }

  function ensureEntryDetails(entry) {
    if (!entry || !entry.variantId) {
      return Promise.resolve(null);
    }

    var needsFetch = !entry.productTitle || !entry.productUrl || !entry.productImage || !entry.productBrand;

    if (!needsFetch) {
      return Promise.resolve(entry);
    }

    return fetch('/variants/' + encodeURIComponent(entry.variantId) + '.js')
      .then(function(response) {
        if (!response.ok) {
          return entry;
        }
        return response.json();
      })
      .then(function(variant) {
        if (!variant) {
          return entry;
        }

        var updated = false;

        if (!entry.productTitle && (variant.name || variant.product_title)) {
          entry.productTitle = variant.name || variant.product_title;
          updated = true;
        }

        if (!entry.productUrl && variant.url) {
          entry.productUrl = variant.url;
          updated = true;
        }

        if (!entry.productHandle && variant.product_handle) {
          entry.productHandle = variant.product_handle;
          updated = true;
        }

        if (!entry.productHandle && variant.url) {
          entry.productHandle = extractHandleFromUrl(variant.url);
          if (entry.productHandle) {
            updated = true;
          }
        }

        if (!entry.productBrand) {
          var variantBrand = variant.vendor || (variant.product && variant.product.vendor) || '';
          if (variantBrand) {
            entry.productBrand = String(variantBrand).trim();
            updated = true;
          }
        }

        if (!entry.productImage && variant.featured_image && variant.featured_image.src) {
          entry.productImage = variant.featured_image.src;
          updated = true;
        }

        if (!entry.productImageAlt && variant.featured_image && variant.featured_image.alt) {
          entry.productImageAlt = variant.featured_image.alt;
          updated = true;
        }

        if ((entry.productPrice === undefined || entry.productPrice === null) && variant.price) {
          entry.productPrice = parseInt(variant.price, 10);
          updated = true;
        }

        if ((entry.productComparePrice === undefined || entry.productComparePrice === null) && variant.compare_at_price) {
          entry.productComparePrice = parseInt(variant.compare_at_price, 10);
          updated = true;
        }

        if (updated) {
          entry.__updated = true;
        }

        return entry;
      })
      .catch(function() {
        return entry;
      });
  }

  function removeFavorite(variantId) {
    var wishlist = getWishlist();
    var filtered = [];
    var removed = false;

    for (var i = 0; i < wishlist.length; i++) {
      if (wishlist[i].variantId === variantId) {
        removed = true;
        continue;
      }
      filtered.push(wishlist[i]);
    }

    if (!removed) {
      return;
    }

    setWishlist(filtered);
    announce('Removed from favorites.');
  }

  function getWishlist() {
    var stored;
    try {
      stored = JSON.parse(localStorage.getItem(WISHLIST_STORAGE_KEY));
    } catch (error) {
      stored = [];
    }

    if (!Array.isArray(stored)) {
      return [];
    }

    var entries = [];
    var seen = {};

    for (var i = 0; i < stored.length; i++) {
      var entry = normalizeEntry(stored[i]);
      if (!entry) {
        continue;
      }
      seen[entry.variantId] = mergeEntries(seen[entry.variantId], entry);
    }

    for (var key in seen) {
      if (Object.prototype.hasOwnProperty.call(seen, key)) {
        entries.push(seen[key]);
      }
    }

    return entries;
  }

  function setWishlist(entries) {
    var normalized = [];
    var seen = {};

    for (var i = 0; i < entries.length; i++) {
      var entry = normalizeEntry(entries[i]);
      if (!entry) {
        continue;
      }
      seen[entry.variantId] = mergeEntries(seen[entry.variantId], entry);
    }

    for (var key in seen) {
      if (Object.prototype.hasOwnProperty.call(seen, key)) {
        normalized.push(seen[key]);
      }
    }

    try {
      localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(normalized));
    } catch (error) {
      console.error('Error saving wishlist:', error);
    }

    window.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        detail: {
          wishlist: normalized
        }
      })
    );
  }

  function normalizeEntry(rawEntry) {
    if (!rawEntry) {
      return null;
    }

    if (typeof rawEntry === 'string' || typeof rawEntry === 'number') {
      return {
        variantId: String(rawEntry)
      };
    }

    if (typeof rawEntry === 'object' && rawEntry.variantId) {
      var entry = {
        variantId: String(rawEntry.variantId)
      };

      if (rawEntry.productUrl) {
        entry.productUrl = String(rawEntry.productUrl);
      }
      if (rawEntry.productHandle) {
        entry.productHandle = String(rawEntry.productHandle);
      }
      if (rawEntry.productBrand) {
        var brand = String(rawEntry.productBrand).trim();
        if (brand) {
          entry.productBrand = brand;
        }
      }
      if (rawEntry.productTitle) {
        entry.productTitle = String(rawEntry.productTitle);
      }
      if (rawEntry.productImage) {
        entry.productImage = String(rawEntry.productImage);
      }
      if (rawEntry.productImageAlt) {
        entry.productImageAlt = String(rawEntry.productImageAlt);
      }
      if (
        rawEntry.productPrice !== undefined &&
        rawEntry.productPrice !== null &&
        String(rawEntry.productPrice).trim() !== '' &&
        !isNaN(rawEntry.productPrice)
      ) {
        entry.productPrice = parseInt(rawEntry.productPrice, 10);
      }
      if (
        rawEntry.productComparePrice !== undefined &&
        rawEntry.productComparePrice !== null &&
        String(rawEntry.productComparePrice).trim() !== '' &&
        !isNaN(rawEntry.productComparePrice)
      ) {
        entry.productComparePrice = parseInt(rawEntry.productComparePrice, 10);
      }

      return entry;
    }

    return null;
  }

  function mergeEntries(existing, incoming) {
    if (!existing) {
      return incoming;
    }
    if (!incoming) {
      return existing;
    }

    var merged = {
      variantId: incoming.variantId || existing.variantId
    };

    merged.productUrl = incoming.productUrl || existing.productUrl || '';
    merged.productHandle = incoming.productHandle || existing.productHandle || '';
    var incomingBrand = typeof incoming.productBrand === 'string' ? incoming.productBrand.trim() : incoming.productBrand;
    var existingBrand = typeof existing.productBrand === 'string' ? existing.productBrand.trim() : existing.productBrand;
    merged.productBrand = incomingBrand || existingBrand || '';
    merged.productTitle = incoming.productTitle || existing.productTitle || '';
    merged.productImage = incoming.productImage || existing.productImage || '';
    merged.productImageAlt = incoming.productImageAlt || existing.productImageAlt || '';

    if (incoming.productPrice !== undefined && !isNaN(incoming.productPrice)) {
      merged.productPrice = incoming.productPrice;
    } else if (existing.productPrice !== undefined) {
      merged.productPrice = existing.productPrice;
    }

    if (incoming.productComparePrice !== undefined && !isNaN(incoming.productComparePrice)) {
      merged.productComparePrice = incoming.productComparePrice;
    } else if (existing.productComparePrice !== undefined) {
      merged.productComparePrice = existing.productComparePrice;
    }

    return merged;
  }

  function extractHandleFromUrl(url) {
    if (!url) {
      return '';
    }

    var cleanUrl = url.split('?')[0];
    var segments = cleanUrl.split('/');
    var productsIndex = -1;

    for (var i = 0; i < segments.length; i++) {
      if (segments[i] === 'products') {
        productsIndex = i;
        break;
      }
    }

    if (productsIndex !== -1 && segments[productsIndex + 1]) {
      return segments[productsIndex + 1];
    }

    return segments.length ? segments[segments.length - 1] : '';
  }

  function getProductUrl(entry) {
    if (entry.productUrl) {
      return entry.productUrl;
    }

    if (entry.productHandle) {
      return '/products/' + entry.productHandle + '?variant=' + encodeURIComponent(entry.variantId);
    }

    return '';
  }

  function escapeHtml(string) {
    if (string === undefined || string === null) {
      return '';
    }

    return String(string)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function escapeHtmlAttribute(string) {
    return escapeHtml(string).replace(/`/g, '&#096;');
  }

  function formatMoney(amount) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var formatPattern = '${{amount}}';
      if (window.theme && window.theme.moneyFormat) {
        formatPattern = window.theme.moneyFormat;
      } else if (window.Shopify.money_format) {
        formatPattern = window.Shopify.money_format;
      }
      return window.Shopify.formatMoney(amount, formatPattern);
    }

    var value = parseFloat(amount);
    if (isNaN(value)) {
      return '';
    }

    return '$' + (value / 100).toFixed(2);
  }

  function announce(message) {
    if (!statusMessage) {
      return;
    }

    statusMessage.textContent = message || '';
  }
})();
